import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import uuid from "react-uuid";

import { Modal, ProductManagerContainer } from "../../../styled/setting";
import { defaultProduct, status } from "../../../function/store";

import ProductList from "./productManager/productList";
import DetailProduct from "./productManager/detailProduct";
import AddProduct from "./productManager/addProduct";
import EditProduct from "./productManager/editProduct";
import LinkOptions from "./productManager/linkOptions";
import { IoClose } from "react-icons/io5";

const ProductManager = ({
  products,
  openModal,
  closeModal,
  clickImages,
  toggleModal,
  getProducts,
  categoriesObj,
  selectCompany,
  optionGroup,
  menuGroup = null,
  getMenuGroup,
  changeStatus,
}) => {
  const [searched, setSearched] = useState("");
  const [data, setData] = useState([]);
  const [context, setContext] = useState(null);
  const [selected, setSelected] = useState(null);
  const [active, setActive] = useState(0);
  const [prevActive, setPrevActive] = useState(0);
  const [options, setOptions] = useState([]);
  const [initialOptions, setInitialOptions] = useState([]);
  const [product, setProduct] = useState(defaultProduct);
  const [checked, setChecked] = useState([]);

  useEffect(() => {
    const products = menuGroup?.products || [];

    setChecked(products.map((p) => p.id));

    const selection = products.find((p) => p.target);
    if (selection) {
      const { target, ...rest } = selection;
      changeTab(2, rest);
    }
  }, []);

  useEffect(() => {
    setData([...products]);
  }, [products]);

  const searchProduct = (flag = false) => {
    setData(flag ? products : products.filter((ele) => ele.name.includes(searched)));
  };

  const toggleAllCheck = () => {
    if (checked.length === data.length) {
      setChecked([]);
    } else {
      setChecked([...data].map(({ id }) => id));
    }
  };

  const toggleCheck = (item) => {
    const target = checked.find((ele) => ele === item.id);
    if (target) {
      setChecked((prev) => prev.filter((ele) => ele !== item.id));
    } else {
      setChecked((prev) => [...prev, item.id]);
    }
  };

  const isUpdate = () => {
    if (!menuGroup || !checked.length) return;

    const originIds = menuGroup.products.map(({ id }) => String(id)).sort();
    const checkedIds = [...checked].map(String).sort();

    const removed = originIds.filter((id) => !checkedIds.includes(id));
    const added = checkedIds.filter((id) => !originIds.includes(id));

    if (removed.length === 0 && added.length === 0) {
      toast.error("선택하신 메뉴가 기존과 동일합니다.");
      return;
    }

    openModal({
      type: "confirmation",
      title: "메뉴 그룹 연결",
      message: [
        removed.length > 0 && `기존에 연결된 ${removed.length}개의 메뉴를 제외하고`,
        `${checked.length}개의 메뉴를 연결하시겠습니까?`,
      ].filter(Boolean),
      handleConfirm: () => updateMenuGroup(checked),
    });
  };

  const updateMenuGroup = async (checked) => {
    try {
      const url = "/erp/menuGroup/update";
      const body = {
        input: {
          id: menuGroup.id,
          name: menuGroup.name,
          menuPlatform: menuGroup.menuPlatform,
          cmpnyNo: selectCompany.value,
          productIds: (checked || []).map((id) => Number(id)),
        },
      };

      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("메뉴 연결이 완료되었습니다.");
        toggleModal();
        await getMenuGroup();
      }
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  const changeSlide = (idx) => {
    setPrevActive(active);
    setActive(idx);
  };

  const changeTab = async (idx, item = null) => {
    changeSlide(idx);
    setSelected(item);

    if (item) {
      setProduct({
        ...item,
        media: (item?.media || []).map((file) => ({ path: file, id: uuid() })),
        description: item.description
          ? item.description.replace(
              /<img\s+[^>]*src=["'](cdn\/[^"']+)["'][^>]*>/g,
              (_, src) => `<img src="${imgHandler(src)}">`,
            )
          : "",
        price: `${item.price}`,
      });
      await getOption(item.id);
    } else {
      setProduct(defaultProduct);
    }
  };

  const isDelete = (items) => {
    const length = items.length;
    if (!length) return;

    let message =
      length === 1
        ? `${chooseParticle(
            data.find((item) => String(item.id) === items[0])?.name,
            "을를",
          )} 삭제하시겠습니까?`
        : `선택하신 상품 ${length}개를 삭제하시겠습니까?`;

    openModal({
      type: "confirmation",
      title: "상품 삭제",
      message: [message, "메뉴 그룹 및 옵션 그룹에서도 함께 삭제됩니다."],
      handleConfirm: () => deleteProduct(items),
    });
  };

  const deleteProduct = async (ids) => {
    const url = "/erp/vendorProducts/delete";
    const body = { ids: [...ids], cmpnyNo: selectCompany.value };
    const res = await axios.post(url, body);
    if (res.status === 200) {
      toast.success("선택하신 상품이 삭제되었습니다.");
      await getProducts();
      await getMenuGroup();
      closeModal();
    }
  };

  const getOption = async (vendorProductId) => {
    const url = "/erp/option/get";
    const body = { vendorProductId, admin: true };
    try {
      const res = await axios.post(url, body);
      setOptions(res.data);
      setInitialOptions(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const clickAdd = () => {
    changeTab(3);
  };

  const closeForm = () => {
    setOptions([]);
    setProduct(defaultProduct);
    changeTab(0, null);
    closeModal();
    setChecked((menuGroup?.products || []).map((product) => product.id));
  };

  const slides = [
    <ProductList
      {...{
        products,
        clickAdd,
        toggleCheck,
        toggleAllCheck,
        data,
        clickImages,
        context,
        setContext,
        changeStatus,
        changeTab,
        isDelete,
        checked,
        setSearched,
        searched,
        searchProduct,
        getMenuGroup,
        menuGroup,
      }}
    />,
    <DetailProduct {...{ selected, categoriesObj, changeTab, clickImages, initialOptions }} />,
    <EditProduct
      {...{
        selectCompany,
        selected,
        categoriesObj,
        openModal,
        closeModal,
        getProducts,
        clickImages,
        product,
        setProduct,
        closeForm,
        options,
        setOptions,
        initialOptions,
        toggleModal,
        changeSlide,
        setPrevActive,
        getMenuGroup,
      }}
    />,
    <AddProduct
      {...{
        selectCompany,
        categoriesObj,
        openModal,
        closeModal,
        getProducts,
        clickImages,
        product,
        setProduct,
        closeForm,
        toggleModal,
        options,
        setOptions,
        initialOptions: [],
        changeSlide,
        setPrevActive,
      }}
    />,
    <LinkOptions
      {...{ changeTab, product, optionGroup, options, setOptions, changeSlide, prevActive }}
    />,
  ];

  const getSlideIndex = (active) => {
    if (active === 0) return 0;
    if ([1, 2, 3].includes(active)) return 1;
    if (active === 4) return 2;
    return 0;
  };

  return (
    <Modal onClick={(e) => e.target === e.currentTarget && toggleModal()}>
      <div className="product modal">
        <ProductManagerContainer>
          <button className="closeModal" onClick={() => toggleModal()}>
            <IoClose />
          </button>
          <div className="slideWrapper">
            <div
              className="slideContent"
              style={{ transform: `translateX(-${getSlideIndex(active) * 100}%)` }}>
              <ProductList
                products={products}
                clickAdd={clickAdd}
                toggleCheck={toggleCheck}
                toggleAllCheck={toggleAllCheck}
                data={data}
                clickImages={clickImages}
                context={context}
                setContext={setContext}
                changeStatus={changeStatus}
                changeTab={changeTab}
                isDelete={isDelete}
                checked={checked}
                setSearched={setSearched}
                searched={searched}
                searchProduct={searchProduct}
                isUpdate={isUpdate}
                menuGroup={menuGroup}
              />
            </div>
            <div
              className="slideContent"
              style={{ transform: `translateX(-${getSlideIndex(active) * 100}%)` }}>
              {slides[[1, 2, 3].includes(active) ? active : prevActive]}
            </div>
            <div
              className="slideContent"
              style={{ transform: `translateX(-${getSlideIndex(active) * 100}%)` }}>
              {slides[4]}
            </div>
          </div>
        </ProductManagerContainer>
      </div>
    </Modal>
  );
};

export default ProductManager;
